import React from "react";
import { reportError } from "@/lib/errorReporter";

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, message: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, message: error?.message || "Unexpected error" };
    }
    componentDidCatch(error, info) {
        reportError(error, { context: { componentStack: info?.componentStack?.slice(0, 4000) } });
    }
    render() {
        if (this.state.hasError) {
            return (
                <div data-testid="error-boundary" className="min-h-[60vh] flex items-center justify-center p-8">
                    <div className="max-w-md text-center">
                        <div className="font-mono-tr text-[11px] tracking-[0.2em] uppercase text-rose-600 mb-2">· Something broke</div>
                        <h2 className="font-display text-2xl tracking-tight text-slate-900">We hit an unexpected error.</h2>
                        <p className="mt-3 text-[14px] text-slate-600">The Toothrocket team has been notified. Try reloading — if it keeps happening, email <a href="mailto:orders@toothrocket.com" className="text-cyan-700 underline">orders@toothrocket.com</a>.</p>
                        <button
                            onClick={() => window.location.reload()}
                            data-testid="error-boundary-reload"
                            className="mt-6 px-5 py-2.5 rounded-full bg-slate-900 text-white text-[13px] font-medium"
                        >
                            Reload page
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
